export default "__VITE_ASSET__IlsdV3SO__"